import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articleSlugs, getArticleContent } from '@/mocks/articles';

export default function ArticleSection() {
  const { t, i18n } = useTranslation();
  const raw = i18n.language || 'en';
  const lang = raw.split('-')[0];

  return (
    <section id="guide" className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t('articleSection.title')}
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            {t('articleSection.subtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articleSlugs.map((slug, idx) => {
            const content = getArticleContent(slug, lang);
            if (!content) return null;
            return (
              <Link
                key={slug}
                to={`/article/${slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-white overflow-hidden cursor-pointer transition-all hover:border-primary-300"
              >
                <div className="flex items-center justify-between gap-2 px-5 pt-5">
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className="ri-article-line text-lg" />
                  </span>
                  <span className="text-xs font-semibold text-foreground-400">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug">
                    {content.h1}
                  </h3>
                  <p className="mt-2 text-foreground-600 text-sm leading-relaxed line-clamp-3">
                    {content.metaDescription}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 group-hover:gap-2.5 transition-all">
                    {t('article.readGuide')}
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}